import React from "react";
import { useTranslation } from "react-i18next";

export default function AppealLandingAlertBody() {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <span>{t('Common.landing-note-two')}</span>
        </React.Fragment>
    )
}